import { UI_STYLES } from "@/styles/uiStyles";
import { ChatMessageUi } from "../ChatScreenViewModel";
import astrologistMessageAppendix from "@/assets/img/icons/ic_astrologist_message_appendix.svg";  

interface MessageItemAstrologProps {
  message: ChatMessageUi;
}

export const MessageItemAstrolog = ({ message }: MessageItemAstrologProps) => {
  return (
    <div className="w-full flex flex-col p-1" style={{ transform: "scaleY(-1)" }}>
      <div className="flex flex-row items-start justify-start pr-20 ">
        <img
          src={astrologistMessageAppendix}
          alt="astrologist"
          className="w-4 h-7"
        />
        <div className={`flex flex-col gap-2 ${UI_STYLES.bgDarkBlue4} text-white   rounded-tr-xl rounded-bl-xl rounded-br-2xl p-2  text-xs `}>
          <div className="text-left w-full ">
            {message.message}
          </div>
          <div className="text-left">{message.createdAt.toLocaleString()}</div>
        </div>
      </div>
    </div>
  );
};
